export const turnstileConstants = {
  ADD_TOKEN: 'TURNSTILE_ADD_TOKEN',
  REMOVE_TOKEN: 'TURNSTILE_REMOVE_TOKEN',
  VERIFY_TOKEN: 'TURNSTILE_VERIFY_TOKEN',
} as const;
